import keyMirror from 'keymirror'

export default keyMirror({
  PAGE_NOT_FOUND: null,
  GENERIC_ERROR: null,
  SESSION_NOT_FOUND: null,
  UNAUTHORIZED: null,
  TODISTUS_NOT_FOUND: null,
  ORDER_ID_NOT_FOUND: null,
  PAYMENT_FAILED: null,
  ORDER_NOT_FOUND: null,
  RECEIPT_NOT_FOUND: null,
  ORDER_NOT_PAID: null,
  PAYMENT_PENDING_OR_DELAYED: null,
})
